import { useRouteWorkspace } from '../contexts/RouteWorkspaceContext';
import { useWorkspacePresence } from '../hooks/useWorkspacePresence';

const WorkspacePresenceManager = ({ disabled = false, viewingChannelId = null }) => {
  const { workspaceId } = useRouteWorkspace();
  useWorkspacePresence({ workspaceId, disabled, viewingChannelId });
  return null;
};

export default WorkspacePresenceManager;
